import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/index';
// import store from '@/store/index';
import Login from '@/views/Login.vue';
// layout
import EditLayout from '@/views/layout/EditLayout.vue';
// 各view
import Main from '@/views/Main.vue';
import EditMain from '@/views/EditMain.vue';
import InfoMain from '@/views/InfoMain.vue';
import InfoEdit from '@/views/InfoEdit.vue';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
    },
    {
      path: '/edit',
      component: EditLayout,
      children: [
        {
          path: '',
          name: 'EditMain',
          component: EditMain,
        },
      ]
    },
    {
      path: '/edit/info',
      component: EditLayout,
      children: [
        {
          path: '',
          name: 'InfoMain',
          component: InfoMain,
        },
      ]
    },
    {
      path: '/edit/info/edit',
      component: EditLayout,
      children: [
        {
          path: '',
          name: 'InfoEdit',
          component: InfoEdit,
        },
      ]
    },
    {
      path: '/main',
      name: 'Main',
      component: Main,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.path === `/` || to.path === '/main') {
    next();
    return;
  }
  if (store.getters['LoginInfo/login_token'] === null || store.getters['LoginInfo/login_token'] === '') {
    next({path: '/', query: {redirect: to.fullPath, type: 'reload'}});
    return;
  }
  next();
});

export default router;
